/** Shared copy and outbound links for the logged-out Partner Dashboard landing. */

export const PARTNER_LINKS = {
  bookDemo: 'https://calendly.com/homecook/homecook-resource-provider-demo',
  publicSite: 'https://homecookapp.com/',
  resourceProviders: 'https://homecookapp.com/resource-providers',
  foodEntrepreneurs: 'https://homecookapp.com/food-entrepreneurs',
  faq: 'https://homecookapp.com/faq-page',
  resourcePantry: 'https://app.homecookapp.com/',
  compliance: 'https://homecookapp.com/compliance',
  instagram: 'https://www.instagram.com/homecook.app/',
  terms: 'https://homecookapp.com/terms',
  privacy: 'https://homecookapp.com/privacy',
  disclaimer: 'https://homecookapp.com/disclaimer',
  eula: 'https://homecookapp.com/eula',
  contact: 'mailto:info@homecookapp.com',
} as const;

/** Anchor targets used by the header nav and in-page CTAs. */
export const PARTNER_SECTION_IDS = {
  auth: 'partner-auth',
  value: 'partner-value',
  how: 'partner-how',
  impact: 'partner-impact',
} as const;

export const HOW_IT_WORKS = [
  {
    step: 1,
    heading: 'Complete your profile',
    description: 'List your kitchen, equipment, and hours once. Your public listing builds itself.',
  },
  {
    step: 2,
    heading: 'Preview booking requests',
    description: 'Every request arrives with the food business, their plan, and what they need.',
  },
  {
    step: 3,
    heading: 'Control your availability',
    description: 'Open only the calendar slots you want. Blackout dates and limits stay yours.',
  },
  {
    step: 4,
    heading: 'Track usage and payments',
    description: 'Approve, invoice, and get paid through Stripe without chasing anyone.',
  },
] as const;

export const FEATURE_SECTIONS = [
  {
    id: 'revenue',
    kicker: 'Revenue',
    heading: 'Diversify revenue streams',
    accent: 'Diversify',
    description:
      'Turn idle hours into recurring income. Publish membership plans, hourly rates, and add-ons, then let pre-vetted food entrepreneurs book the capacity you already pay for.',
    bullets: ['Membership tiers and hourly pricing', 'Add-on inventory and storage', 'Stripe payouts with clear statements'],
  },
  {
    id: 'operations',
    kicker: 'Operations',
    heading: 'Seamlessly manage bookings',
    accent: 'Seamlessly',
    description:
      'One calendar for every resource: kitchen space, equipment, storage, and training rooms. Approve requests, message members, and keep compliance documents attached to each account.',
    bullets: ['Calendar and request queue in one place', 'Member messaging and credential tracking', 'Setup checklist for local compliance'],
  },
  {
    id: 'community',
    kicker: 'Community',
    heading: 'Bring your community to HomeCook',
    accent: 'Bring',
    description:
      'Programs, incubators, and nonprofits run their cohorts here. Share resources, onboard members with agreements, and show funders what your space is producing.',
    bullets: ['Member agreements and onboarding', 'Cohort and program reporting', 'Insights you can hand to a funder'],
  },
] as const;

export const IMPACT_POINTS = [
  {
    label: 'Essential resources',
    description: 'Kitchens, farms, training, documentation, funding and expert time all book through one dashboard.',
  },
  {
    label: 'Payments built in',
    description: 'Stripe Connect handles payouts, refunds, and disputes so operators are not invoicing by hand.',
  },
  {
    label: 'Built with programs',
    description: 'Designed alongside food-business incubators and nonprofit kitchens supporting early-stage founders.',
  },
] as const;
